import React, { useState } from 'react';
import { products } from '../data/mockData';
import ProductCard from './ProductCard';

const categories = [
  { id: 'all', label: 'All Gear' },
  { id: 'upper-body', label: 'Upper Body' },
  { id: 'leg-day', label: 'Leg Day' },
  { id: 'active-recovery', label: 'Active Recovery' }
];

const ShopSection = () => {
  const [activeTab, setActiveTab] = useState('all');

  const filteredProducts = activeTab === 'all' 
    ? products 
    : products.filter(p => p.category === activeTab);

  return (
    <section id="shop" className="py-24 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-6">
          <div>
            <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tight mb-2">Build Your Arsenal</h2>
            <p className="text-zinc-400">Targeted tools for specific training demands.</p>
          </div>
          
          {/* Mobile Scrollable Tabs, Desktop Flex */}
          <div className="flex overflow-x-auto hide-scrollbar w-full md:w-auto gap-2 pb-2 md:pb-0 border-b md:border-none border-zinc-800">
            {categories.map(cat => (
              <button
                key={cat.id}
                onClick={() => setActiveTab(cat.id)}
                className={`whitespace-nowrap px-4 py-2 text-sm font-bold uppercase tracking-wider rounded-sm transition-colors ${
                  activeTab === cat.id 
                    ? 'bg-red-600 text-white' 
                    : 'bg-zinc-900 text-zinc-400 hover:text-white hover:bg-zinc-800'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>

        {/* Mobile First Product Flow: Horizontal scroll on small screens, Grid on large */}
        <div className="flex md:grid overflow-x-auto md:overflow-visible snap-x snap-mandatory hide-scrollbar gap-6 md:grid-cols-2 lg:grid-cols-4 pb-8">
          {filteredProducts.map(product => (
            <div key={product.id} className="snap-center shrink-0 w-[85vw] md:w-auto">
              <ProductCard product={product} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ShopSection;